import { createBrowserRouter } from 'react-router';
import { Root } from './App';
import { Home } from './routes/Home';
import { NotFound } from './routes/NotFound';
import { RoomLobby } from './routes/RoomLobby';
import { RoomsBrowser } from './routes/RoomsBrowser';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <NotFound />,
    hydrateFallbackElement: <div style={{ minHeight: '100dvh' }} />,
    children: [
      { index: true, element: <Home /> },
      { path: 'salas', element: <RoomsBrowser /> },
      { path: 'sala/:code', element: <RoomLobby /> },
      { path: 'partida/:gameId', lazy: async () => ({ Component: (await import('./routes/GamePage')).GamePage }) },
      { path: 'partida/:gameId/resultados', lazy: async () => ({ Component: (await import('./routes/Results')).Results }) },
      { path: 'jugador/:username', lazy: async () => ({ Component: (await import('./routes/PlayerStats')).PlayerStats }) },
      { path: 'historial/:matchId', lazy: async () => ({ Component: (await import('./routes/MatchDetail')).MatchDetail }) },
      { path: 'reglas', lazy: async () => ({ Component: (await import('./routes/RulesPage')).RulesPage }) },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
